import { Link } from "react-router-dom";
import { ArrowRight, Lightning } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";

export function QuizPromo({ testid = "quiz-promo-card", className = "" }) {
  return (
    <div className={`glass p-5 flex flex-wrap items-center justify-between gap-4 fade-up ${className}`} data-testid={testid}>
      <div className="flex items-center gap-3">
        <span className="grid place-items-center h-10 w-10 rounded-xl bg-gradient-to-br from-emerald-500 to-cyan-500 text-white shrink-0"><Lightning size={20} weight="fill" /></span>
        <div>
          <p className="font-display font-semibold">Tell us what you think: 3-question quiz</p>
          <p className="text-sm text-muted-foreground">Tried the tools? Answer 3 quick questions and share your take with coworkers. Free &amp; unlimited for everyone.</p>
        </div>
      </div>
      <Link to="/check"><Button className="rounded-full" data-testid={`${testid}-button`}>Take the quiz<ArrowRight size={16} className="ml-1.5" /></Button></Link>
    </div>
  );
}
